module.exports = "/_next/static/images/slashing_pink-614f2d6d58dcc826dc9da0114d6489be.svg";